module.exports = __webpack_public_path__ + "img/datepaper2.c5e4a58c.png";